import {Injectable} from '@angular/core';
import {Options} from "highcharts";

@Injectable({
  providedIn: 'root'
})
export class ColumnChartService {

  public static getOptions(text, x_categories, y_value, nData, y_min, y_max, backgroundColor, height) {
    let options: Options = {
      chart: {
        type: 'column',
        backgroundColor: backgroundColor,
        reflow: true,
        height: height,
        style: {
          fontFamily: 'TT Commons'
        }
      },
      credits: {enabled: false},
      legend: {enabled: false},
      title: {
        text: text,
        verticalAlign: "bottom",
        style: {
          fontSize: '16px'
        }
      },
      tooltip: {enabled: false},
      xAxis: {
        categories: x_categories,
        title: {
          text: ''
        },
        lineColor: 'transparent',
        labels: {
            style: {
                fontFamily: 'TT Commons',
                fontSize: '13px'
            }
        },
        opposite: true
      },
      yAxis: {
        min: y_min,
        max: y_max,
        title: {
          text: ''
        },
        labels: {
          enabled: false
        },
        gridLineWidth: 0,
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: false
          },
          pointWidth: 15,
        },
        series: {
          stacking: 'normal',
          enableMouseTracking: false
        },
      },
      series: [
        {
          type: 'bar',
          data: nData,
          color: '#FFF'
        },
        {
          type: 'bar',
          data: y_value
        }
      ]
    };
    return options;
  }
}
